module.exports = __webpack_public_path__ + "static/media/LAT3130.6344087c.pdf";